import request from '@/utils/request'
import { ConstConfig, AppType } from '@/utils'

export function getPlayerList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetPlayerList.json',
    method: 'get',
    params
  })
}

export function getCoachList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetCoachList.json',
    method: 'get',
    params
  })
}

export function getOrderInfo(data) {
  return request({
    url: ConstConfig.apiPath + '/GetMembershipFeeOrderInfo.json',
    method: 'post',
    data
  })
}

export function getWPUnifiedOrder(data) {
  return request({
    url: ConstConfig.apiPath + '/GetWPUnifiedOrder.json',
    method: 'post',
    data
  })
}

export function getZhifubao(data) {
  return request({
    url: ConstConfig.apiPath + '/GetAliPayPageContent.json',
    method: 'post',
    data
  })
}

export function getWechatToken(params) {
  return request({
    url: ConstConfig.apiPath + '/GetWechatToken.json',
    method: 'get',
    params
  })
}

export function exportOrganizationPlayers(params) {
  return request({
    url: ConstConfig.apiPath + '/ExportOrganizationPlayers.json',
    method: 'get',
    params
  })
}


export function exportOrganizationCoaches(params) {
  return request({
    url: ConstConfig.apiPath + '/ExportOrganizationCoaches.json',
    method: 'get',
    params
  })
}

export function updateOrganizationPlayerStatus(params) {
  return request({
    url: ConstConfig.apiPath + '/UpdateOrganizationPlayerStatus.json',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/member.js